export const state = () => ({
  open: false,
})

export const mutations = {
  setOverlay: (state, payload) => {
    state.open = payload
  },
}
